<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter
                    v-if="showBlock.payTypeText || showBlock.amount || showBlock.payDateList"
                    title="投資設定"
                >
                    <template #before>
                        <div v-if="before.terminate">
                            <div class="text-lg">
                                無申請定期定額保費投資
                            </div>
                        </div>
                        <div
                            v-else
                            class="divide-y divide-dashed divide-gray-200"
                        >
                            <div
                                v-if="before.showPayType && showBlock.payTypeText"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7">
                                    繳別
                                </div>
                                <div class="text-lg">
                                    {{ !before.payTypeText ? '未指定' : before.payTypeText }}
                                </div>
                            </div>
                            <div
                                v-if="showBlock.amount"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7">
                                    投資金額
                                </div>
                                <div class="text-lg">
                                    {{ addComma(before.amount) }}
                                </div>
                            </div>
                            <div
                                v-if="before.showPayDate && showBlock.payDateList"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7">
                                    指定請款日
                                </div>
                                <div class="text-lg">
                                    {{ payDateDisplay(before.payDateList) }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #after>
                        <div v-if="after.terminate">
                            <div class="text-lg text-gray-900">
                                終止定期定額保費投資
                            </div>
                        </div>
                        <div
                            v-else
                            class="divide-y divide-dashed divide-gray-200"
                        >
                            <div
                                v-if="after.showPayType && showBlock.payTypeText"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7 text-gray-900">
                                    繳別
                                </div>
                                <div class="text-lg text-gray-900">
                                    {{ after.payTypeText }}
                                </div>
                            </div>
                            <div
                                v-if="showBlock.amount"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7 text-gray-900">
                                    投資金額
                                </div>
                                <div class="text-lg text-gray-900">
                                    {{ addComma(after.amount) }}
                                </div>
                            </div>
                            <div
                                v-if="after.showPayDate && showBlock.payDateList"
                                class="grid grid-cols-2 md:grid-cols-3 dashed"
                            >
                                <div class="text-sm md:text-lg leading-7 text-gray-900">
                                    指定請款日
                                </div>
                                <div class="text-lg text-gray-900">
                                    {{ payDateDisplay(after.payDateList) }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ChangeBeforeAfter>

                <ChangeBeforeAfter
                    v-if="showBlock.regularInvestResultDataList"
                    title="配置比例"
                >
                    <template #before>
                        <div v-if="before.terminate">
                            <div class="text-lg">
                                無申請定期定額保費投資
                            </div>
                        </div>
                        <ul
                            v-else-if="before.regularInvestResultDataList.length !==0"
                            class="divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in before.regularInvestResultDataList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0"
                            >
                                <div class="md:mr-4 w-4/5 flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div v-else>
                            未配置
                        </div>
                    </template>
                    <template #after>
                        <div v-if="after.terminate">
                            <div class="text-lg text-gray-900">
                                終止定期定額保費投資
                            </div>
                        </div>
                        <ul
                            v-else-if="after.regularInvestResultDataList.length !==0"
                            class="divide-dashed divide-y -mr-2.5 md:-mr-4"
                        >
                            <li
                                v-for="(item, index) in after.regularInvestResultDataList"
                                :key="index"
                                class="dashed flex item-baseline justify-between pr-2.5 md:pr-4 pl-0 text-gray-900"
                            >
                                <div class="md:mr-4 w-4/5 md:flex-shrink-0">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="px-3 text-right w-16">
                                    <span>
                                        {{ `${item.percent}%` }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { addComma } from '@/utils/number/addComma';
import { makeSort } from '@/utils/array/makeSort';

export default {
    name: 'A4Data',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('A4');
        const removeService = () => {
            emit('removeService', code.value);
        };
        const after = computed(() => data.value.after);
        const before = computed(() => data.value.before);

        const payDateDisplay = computed(() => {
            return (payDateList) => {
                let str = '';
                if (payDateList.length === 0) {
                    str = '未指定';
                } else {
                    const arr = payDateList.map(i => {
                        const str = i + '日';
                        return str;
                    });
                    str = arr.join('、');
                }
                return str;
            };
        });
        /** 比對變更前後 只出現有變更的資料 */
        const showBlock = computed(() => {
            let regularInvestListChange = false;
            if (after.value.regularInvestResultDataList.length === before.value.regularInvestResultDataList.length !== 0) {
                const afterlist = makeSort(after.value.regularInvestResultDataList, 'fundCode');
                const beforelist = makeSort(before.value.regularInvestResultDataList, 'fundCode');
                regularInvestListChange = JSON.stringify(afterlist) !== JSON.stringify(beforelist);
            } else {
                regularInvestListChange = true;
            }
            const change = {
                payTypeText: after.value.payTypeText !== before.value.payTypeText,
                amount: after.value.amount !== before.value.amount,
                payDateList: JSON.stringify(after.value.payDateList) !== JSON.stringify(before.value.payDateList),
                regularInvestResultDataList: regularInvestListChange,
            };
            return change;
        });
        return {
            code,
            showBlock,
            data,
            after,
            before,
            addComma,
            payDateDisplay,
            removeService,
        };
    },
};
</script>
<style lang="scss" scoped>
.dashed {
    @apply pt-1 pb-1 first:pt-0 last:pb-0.5;
}
</style>
